/**
 * Yurtiçi kargo listesindeki "Elle Güncellendi" kolonu (04.10.2026):
 * - Evet: Müşteri / Bölüm / PO / PO No elle güncellendi (kilitli)
 * - Otomatik: "Gönderici - Alıcı Kayıtlı Değil" tanımıyla sistem eşleştirdi (o da kilitli; toplu güncelleme yeniden eşleştirir)
 * - Hayır: kod eşleştirmesiyle ya da hiç eşleşmedi
 * Filtre değerleri backend'deki YurticiCargoManager "isPoManual" filtresiyle aynı: "1" Evet, "2" Otomatik, "0" Hayır.
 */
export const PO_GUNCELLEME = {
    EVET: { value: '1', label: 'Evet' },
    OTOMATIK: { value: '2', label: 'Otomatik' },
    HAYIR: { value: '0', label: 'Hayır' },
}

export const poGuncellemeDurumu = (item: { isPoManual?: boolean, isPoAuto?: boolean }): string =>
    item.isPoManual ? PO_GUNCELLEME.EVET.label : item.isPoAuto ? PO_GUNCELLEME.OTOMATIK.label : PO_GUNCELLEME.HAYIR.label

/** PO eşleşmesi değişti (toplu güncelleme, elle güncelleme, kilit kaldırma): üst bardaki zil hemen yenilenir. */
export const PO_ESLESME_DEGISTI = 'po-eslesme-degisti'
export const poEslesmeDegistiBildir = () => window.dispatchEvent(new Event(PO_ESLESME_DEGISTI))

/** Hücre ipucu: kim/ne zaman. */
export const poGuncellemeIpucu = (item: { isPoManual?: boolean, isPoAuto?: boolean, poManualDateStr?: string, poManualUserName?: string, poAutoDateStr?: string }): string | undefined => {
    if (item.isPoManual)
        return [item.poManualDateStr, item.poManualUserName].filter(x => x).join(' · ') || undefined

    if (item.isPoAuto)
        return ['Gönderici - Alıcı Kayıtlı Değil tanımıyla otomatik eşleşti', item.poAutoDateStr].filter(x => x).join(' · ')

    return undefined
}
